import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createSlots as _createSlots, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "mt-2 nodeinfo3"
};
const _hoisted_2 = {
  class: "row"
};
const _hoisted_3 = {
  class: "col-12"
};
const _hoisted_4 = {
  class: "row mb-3"
};
const _hoisted_5 = {
  class: "i-layer mt-1 mb-3"
};
const _hoisted_6 = {
  class: "row"
};
const _hoisted_7 = {
  class: "col-12"
};
const _hoisted_8 = {
  class: "pl-2 pr-2"
};
const _hoisted_9 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_10 = {
  class: "mr-1"
};
const _hoisted_11 = {
  class: "fw-bold fsi-16",
  style: {
    "color": "#4e4e5c"
  }
};
const _hoisted_12 = {
  class: "fw-bold fsi-24"
};
const _hoisted_13 = {
  class: "col-12 mt-4"
};
const _hoisted_14 = {
  class: "pl-2 pr-2"
};
const _hoisted_15 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_16 = {
  class: "mr-1"
};
const _hoisted_17 = {
  class: "fw-bold fsi-16",
  style: {
    "color": "#4e4e5c"
  }
};
const _hoisted_18 = {
  class: "fw-bold fsi-24"
};
const _hoisted_19 = {
  key: 0,
  class: "col-12 mt-4"
};
const _hoisted_20 = {
  class: "row mt-2"
};
const _hoisted_21 = {
  class: "col-12"
};
const _hoisted_22 = {
  class: "pl-4 pr-4"
};
const _hoisted_23 = {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_24 = {
  class: "mr-1 fw-bold fsi-14"
};
const _hoisted_25 = {
  key: 1,
  class: "col-12"
};
const _hoisted_26 = {
  class: "row mb-3"
};
const _hoisted_27 = {
  key: 0,
  class: "i-layer mt-1 mb-3"
};
const _hoisted_28 = {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_29 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_30 = {
  class: "i-layer mb-4"
};
const _hoisted_31 = {
  class: "row mt-3",
  ref: "nodeinfo3"
};
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-3 col-12 text-left fw-bold fw-lg-medium fsi-14"
}, "Address", -1);
const _hoisted_33 = {
  class: "col-lg-9 col-12 d-flex fw-medium fs-lg-14 fs-12 justify-content-lg-end"
};
const _hoisted_34 = {
  class: "row mt-3"
};
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-3 col-12 text-left fw-bold fw-lg-medium fsi-14"
}, "ID", -1);
const _hoisted_36 = {
  key: 1,
  class: "row mt-3",
  ref: "nodeinfo3"
};
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-3 col-12 text-left fw-bold fw-lg-medium fsi-14"
}, "Address", -1);
const _hoisted_38 = {
  class: "col-lg-9 col-12 d-flex fw-medium fs-lg-14 fs-12 justify-content-lg-end"
};
const _hoisted_39 = {
  class: "row mt-3"
};
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-3 col-12 text-left fw-bold fw-lg-medium fsi-14"
}, "Actor", -1);
const _hoisted_41 = {
  class: "col-lg-9 col-12 text-lg-right fw-medium fs-lg-14 fs-12"
};
const _hoisted_42 = {
  class: "row mt-3"
};
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-5 col-12 text-left fw-bold fw-lg-medium fsi-14"
}, "Approval Threshold", -1);
const _hoisted_44 = {
  class: "col-lg-7 col-12 text-lg-right fw-medium fs-lg-14 fs-12"
};
const _hoisted_45 = {
  class: "row mt-3"
};
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-5 col-12 text-left fw-bold fw-lg-medium fsi-14"
}, "No. of Singer", -1);
const _hoisted_47 = {
  class: "col-lg-7 col-12 text-lg-right fw-medium fs-lg-14 fs-12"
};
const _hoisted_48 = {
  class: "row"
};
const _hoisted_49 = {
  key: 0,
  class: "row"
};
const _hoisted_50 = {
  class: "col-12"
};
const _hoisted_51 = {
  class: "i-layer"
};
const _hoisted_52 = {
  key: 1,
  class: "row mt-4"
};
const _hoisted_53 = {
  class: "col-12"
};
const _hoisted_54 = {
  key: 0,
  class: "row"
};
const _hoisted_55 = {
  class: "col-12"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  const _component_i_skeleton = _resolveComponent("i-skeleton");
  const _component_Tip = _resolveComponent("Tip");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_step = _resolveComponent("el-step");
  const _component_SingerV2 = _resolveComponent("SingerV2");
  const _component_AdCard2 = _resolveComponent("AdCard2");
  const _component_el_steps = _resolveComponent("el-steps");
  const _component_NextBtnGroup = _resolveComponent("NextBtnGroup");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_steps, {
    direction: "vertical",
    active: $data.active
  }, {
    default: _withCtx(() => [_createVNode(_component_el_step, null, _createSlots({
      title: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
        class: _normalizeClass(["col-12 text-left fw-extra-bold", _ctx.isMobileWidth ? 'fsi-16' : 'fsi-20'])
      }, _toDisplayString(_ctx.$t('subpool.induction.connect admin Wallet')), 3)])]),
      _: 2
    }, [!$data.isError ? {
      name: "description",
      fn: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, [_createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('subpool.poolInfoTip.poolAddress')), 1)])]), _createVNode(_component_i_skeleton, {
        loading: _ctx.poolInfoLoading
      }, {
        template: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_skeleton_item, {
          variant: "h3",
          style: {
            "width": "70%"
          }
        })])]),
        default: _withCtx(() => [_createElementVNode("div", {
          class: "fw-bold fsi-16 mt-1 link-text-ordinary",
          style: _normalizeStyle({
            maxWidth: _ctx.fixedMaxWidth
          }),
          onClick: _cache[0] || (_cache[0] = $event => $options.gotoAddress(_ctx.currentPoolAddress, _ctx.$i18n.locale))
        }, [_createElementVNode("span", null, _toDisplayString(_ctx.currentPoolAddress), 1)], 4)]),
        _: 1
      }, 8, ["loading"])])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("span", _hoisted_16, [_createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('subpool.induction.admin')), 1)])]), _createVNode(_component_i_skeleton, {
        loading: _ctx.poolInfoLoading
      }, {
        template: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createVNode(_component_el_skeleton_item, {
          variant: "h3",
          style: {
            "width": "70%"
          }
        })])]),
        default: _withCtx(() => [_createElementVNode("div", {
          class: "fw-bold fsi-16 mt-1 link-text-ordinary",
          style: _normalizeStyle({
            maxWidth: _ctx.fixedMaxWidth
          }),
          onClick: _cache[1] || (_cache[1] = $event => $options.gotoAddress(_ctx.poolAdmin, _ctx.$i18n.locale))
        }, _toDisplayString(_ctx.poolAdmin), 5)]),
        _: 1
      }, 8, ["loading"])])]), !_ctx.isCanNext && _ctx.isConnected ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createVNode(_component_Tip, {
        level: "warring"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('subpool.The caller must be the pool admin')), 1)])])])])]),
        _: 1
      })])) : _createCommentVNode("", true), $data.step <= 0 ? (_openBlock(), _createElementBlock("div", _hoisted_25, [!_ctx.isConnected ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        class: "btn btn-primary w-100 i-button mt-4",
        onClick: $options.connectWallet,
        loading: _ctx.poolInfoLoading
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('subpool.induction.connect admin Wallet')), 1)]),
        _: 1
      }, 8, ["onClick", "loading"])) : _createCommentVNode("", true), _ctx.isConnected && _ctx.isCanNext ? (_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        class: "btn btn-primary w-100 i-button mt-4",
        onClick: $options.nextStep1,
        loading: $data.loading
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Next')), 1)]),
        _: 1
      }, 8, ["onClick", "loading"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])])]),
      key: "0"
    } : undefined]), 1024), _createVNode(_component_el_step, null, _createSlots({
      title: _withCtx(() => [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", {
        class: _normalizeClass(["col-12 text-left fw-extra-bold", _ctx.isMobileWidth ? 'fsi-16' : 'fsi-20'])
      }, [_createElementVNode("span", {
        style: _normalizeStyle({
          maxWidth: _ctx.fixedMaxWidth
        })
      }, _toDisplayString(_ctx.$t('Onboarding.Submit a')) + " \"Change" + _toDisplayString(_ctx.nodeRole === 'Beneficiary' ? _ctx.nodeRole : _ctx.nodeRole + 'Address') + "\" " + _toDisplayString(_ctx.$t('Onboarding.proposal')), 5)], 2)])]),
      _: 2
    }, [!$data.isError ? {
      name: "description",
      fn: _withCtx(() => [$data.step >= 1 ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("span", _hoisted_29, "Original " + _toDisplayString(_ctx.nodeRole), 1)]), _createElementVNode("div", _hoisted_30, [!$data.singerMultiple ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_31, [_hoisted_32, _createElementVNode("div", _hoisted_33, [_createElementVNode("div", {
        class: "link-text-ordinary text-lg-right",
        style: _normalizeStyle({
          maxWidth: _ctx.fixedMaxWidth
        }),
        onClick: _cache[2] || (_cache[2] = $event => $options.gotoAddress(_ctx.nodeInfo[`${_ctx.nodeRole.toString().toLowerCase()}Address`], _ctx.$i18n.locale))
      }, _toDisplayString($data.originalOwner), 5)])], 512), _createElementVNode("div", _hoisted_34, [_hoisted_35, _createElementVNode("div", {
        class: "col-lg-9 col-12 text-lg-right fw-medium fs-lg-14 fs-12 link-text-ordinary",
        onClick: _cache[3] || (_cache[3] = $event => $options.gotoAddress(_ctx.nodeInfo[`${_ctx.nodeRole.toString().toLowerCase()}`], _ctx.$i18n.locale))
      }, _toDisplayString($data.originalOwnerF0), 1)])], 64)) : _createCommentVNode("", true), $data.singerMultiple ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_hoisted_37, _createElementVNode("div", _hoisted_38, [_createElementVNode("div", {
        style: _normalizeStyle(`max-width: ${_ctx.fixedMaxWidth}`),
        class: "link-text-ordinary text-right",
        onClick: _cache[4] || (_cache[4] = $event => $options.gotoAddress(_ctx.nodeInfo[_ctx.nodeRole.toString().toLowerCase()], _ctx.$i18n.locale))
      }, _toDisplayString(_ctx.nodeInfo[_ctx.nodeRole.toString().toLowerCase()]), 5)])], 512)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_39, [_hoisted_40, _createElementVNode("div", _hoisted_41, _toDisplayString($data.singerMultiple ? 'Multisig' : 'Account'), 1)]), $data.singerMultiple ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 2
      }, [_createElementVNode("div", _hoisted_42, [_hoisted_43, _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.singerMultipleThreshold), 1)]), _createElementVNode("div", _hoisted_45, [_hoisted_46, _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.singerMultipleNum), 1)])], 64)) : _createCommentVNode("", true)]), _createVNode(_component_SingerV2, {
        ref: "singer",
        nodeRole: _ctx.nodeRole,
        changeAddress: $data.changeAddress,
        "wait-time": 30000,
        fromAddress: $data.oneStepFromAddress,
        "to-f0-address": $data.oneStepToF0Address,
        "is-call-evm": false,
        contractABI: $data.contractABI,
        onInitErr: $options.singleSignatureInitErr,
        btnProposal: "Send Proposal",
        onNext: $options.showNextStepBtnFun
      }, null, 8, ["nodeRole", "changeAddress", "fromAddress", "to-f0-address", "contractABI", "onInitErr", "onNext"]), $data.showNextStepBtn ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        onClick: $options.pushProposalNext,
        class: "btn btn-primary w-100 i-button",
        type: "submit"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Next')), 1)]),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
      key: "0"
    } : undefined]), 1024), _createVNode(_component_el_step, null, {
      title: _withCtx(() => [_createElementVNode("div", _hoisted_48, [_createElementVNode("div", {
        class: _normalizeClass(["col-12 text-left fw-bold cursor-pointer", _ctx.isMobileWidth ? 'fsi-16' : 'fsi-20'])
      }, _toDisplayString(_ctx.$t('subpool.Approval proposal by STFIL lednding pool')), 3)])]),
      description: _withCtx(() => [_createElementVNode("div", null, [$data.step >= 2 ? (_openBlock(), _createElementBlock("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_createVNode(_component_SingerV2, {
        ref: "singer2",
        nodeRole: _ctx.nodeRole,
        "to-eth-address": $data.towToEthAddress,
        "to-f0-address": $data.towToF0Address,
        waitTime: 30000,
        "contract-method": $data.contractMethod,
        btnProposal: "Approved Proposal",
        contractParams: $data.contractParams,
        contractABI: $data.contractABI,
        "is-call-evm": true,
        onNext: $options.pushProposalNext2
      }, null, 8, ["nodeRole", "to-eth-address", "to-f0-address", "contract-method", "contractParams", "contractABI", "onNext"])])])])) : _createCommentVNode("", true), $data.step >= 3 ? (_openBlock(), _createElementBlock("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, [_ctx.nodeRole.toString() === 'Owner' ? (_openBlock(), _createBlock(_component_AdCard2, {
        key: 0,
        title: _ctx.$t('Onboarding.You have successfully joined'),
        content: _ctx.$t('Onboarding.Please take good care the original owner'),
        "btn-text": _ctx.$t('Onboarding.View Node'),
        onBtnClick: $options.viewNode
      }, null, 8, ["title", "content", "btn-text", "onBtnClick"])) : _createCommentVNode("", true), _ctx.nodeRole.toString() === 'Beneficiary' ? (_openBlock(), _createBlock(_component_AdCard2, {
        key: 1,
        title: _ctx.$t('Onboarding.You have successfully joined'),
        content: _ctx.$t('Onboarding.Please take good care the original owner'),
        "btn-text": _ctx.$t('Onboarding.View Node'),
        "main-btn-text": _ctx.$t('farm.console.ApproveOperator'),
        onBtnClick: $options.viewNode,
        onMainBtnClick: $options.ApproveOperator
      }, null, 8, ["title", "content", "btn-text", "main-btn-text", "onBtnClick", "onMainBtnClick"])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)])]),
      _: 1
    })]),
    _: 1
  }, 8, ["active"])])]), false ? (_openBlock(), _createElementBlock("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, [_createVNode(_component_NextBtnGroup, {
    onNext: $options.next,
    "show-pre": $data.step < 3,
    showNext: false,
    onPre: $options.pre
  }, null, 8, ["onNext", "show-pre", "onPre"])])])) : _createCommentVNode("", true)]);
}